loadjs.ready(['jquery', 'core'], function() {
    var $reviewsCard = $('#shop-reviews-card');
    $reviewsCard
        .on('click', '.pagination-link', function() {
            var $el = $(this);
            var isNext = $el.is('.next');
            var url = $el.attr('href');
            var $content = $el.closest('.reviews-container');
            preloader(true);
            $content[0].scrollIntoView();

            $.get(url, function (response) {
                $content
                    .html(response)
                    .find('.icon').icon();

                preloader(false);
            });
            if (typeof product !== 'undefined' && product.id) {
                gtag('event', 'product_reviews_pagination', {
                    'event_label': product.id,
                    'event_category': 'product_events',
                    'value': isNext ? 1 : -1,
                    'non_interaction': true
                });
            }
            return false;
        })

    updateFragment('reviews-list', function($fragment) {
        var count = parseInt($fragment.find('.review-stats').data('count'));
        $reviewsCard.find('.reviews-count').html(`${count} ${count !== 1 ? 'recenzii' : 'recenzie'}`)
    }, true)
});